import { Subject } from "rxjs";
import { Directive, OnDestroy } from "@angular/core";

@Directive()
export class BaseComponent implements OnDestroy {
  public ngUnsubscribe$: Subject<void> = new Subject();

  constructor() {}

  public ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
